var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import fetch from 'cross-fetch';
import createError from 'http-errors';
import defaultErrorHandler from '../utils/defaultErrorHandler';
import defaultResponseHandler from '../utils/defaultResponseHandler';
import defaultPreflightHandler from '../utils/defaultPreflightHandler';
import buildUrl from '../utils/buildUrl';
import browserFetch from './browserFetch';
var HttpClient = /** @class */ (function () {
    function HttpClient(opts) {
        if (opts === void 0) { opts = {}; }
        var _a, _b, _c, _d, _e;
        this.baseUrl = opts.baseUrl;
        // Fallback to browser fetch is needed because cross-fetch uses GitHub's polyfill
        // fetch implementation which doesn't support advanced use cases like fetch "mode".
        this.fetchImpl = (_b = (_a = opts.fetchImpl) !== null && _a !== void 0 ? _a : browserFetch) !== null && _b !== void 0 ? _b : fetch;
        this.logger = opts.logger;
        this.errorHandler = (_c = opts.errorHandler) !== null && _c !== void 0 ? _c : defaultErrorHandler;
        this.responseHandler = (_d = opts.responseHandler) !== null && _d !== void 0 ? _d : defaultResponseHandler;
        this.preflightHandler = (_e = opts.preflightHandler) !== null && _e !== void 0 ? _e : defaultPreflightHandler;
    }
    HttpClient.prototype.log = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.info.apply(_a, args);
    };
    HttpClient.prototype.makeRequest = function (url, opts) {
        return __awaiter(this, void 0, void 0, function () {
            var fetchUrl, preflightArgs_1, response, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 6]);
                        fetchUrl = buildUrl(url, this.baseUrl, opts.searchParams);
                        preflightArgs_1 = {
                            url: fetchUrl,
                            options: opts
                        };
                        // preflightArgs can be modified within the function.
                        return [4 /*yield*/, this.preflightHandler(preflightArgs_1)];
                    case 1:
                        // preflightArgs can be modified within the function.
                        _a.sent();
                        this.log("Outgoing ".concat(opts.method, " request: ").concat(preflightArgs_1.url));
                        return [4 /*yield*/, this.fetchImpl(preflightArgs_1.url, preflightArgs_1.options).catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
                                var danceOpts;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                                            if (!opts.handleOAuthFlow) {
                                                throw err;
                                            }
                                            danceOpts = __assign(__assign({}, preflightArgs_1.options), { mode: 'no-cors', method: 'GET', credentials: 'include' });
                                            this.log("Making no-cors request: ".concat(preflightArgs_1.url));
                                            // Perform the no-cors request. This should always succeed, but session cookie
                                            // may or may not be set depending on if you're logged
                                            return [4 /*yield*/, this.fetchImpl(preflightArgs_1.url, danceOpts)];
                                        case 1:
                                            // Perform the no-cors request. This should always succeed, but session cookie
                                            // may or may not be set depending on if you're logged
                                            _a.sent();
                                            this.log("no-cors request succeeded, making original request: ".concat(preflightArgs_1.url));
                                            return [4 /*yield*/, this.fetchImpl(preflightArgs_1.url, preflightArgs_1.options)];
                                        case 2: 
                                        // Send the real network request with original options. If there is no valid session,
                                        // this will fail.
                                        return [2 /*return*/, _a.sent()];
                                    }
                                });
                            }); })];
                    case 2:
                        response = _a.sent();
                        if (response.status >= 400) {
                            throw createError(response.status, response.statusText, { response: response });
                        }
                        return [4 /*yield*/, this.responseHandler(response)];
                    case 3: return [2 /*return*/, (_a.sent())];
                    case 4:
                        err_1 = _a.sent();
                        return [4 /*yield*/, this.errorHandler(err_1)];
                    case 5: return [2 /*return*/, (_a.sent())];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    HttpClient.prototype.get = function (url, opts) {
        if (opts === void 0) { opts = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest(url, __assign(__assign({}, opts), { method: 'GET' }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpClient.prototype.post = function (url, opts) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest(url, __assign(__assign({}, opts), { method: 'POST' }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpClient.prototype.put = function (url, opts) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest(url, __assign(__assign({}, opts), { method: 'PUT' }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpClient.prototype.del = function (url, opts) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest(url, __assign(__assign({}, opts), { method: 'DELETE' }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpClient.prototype.patch = function (url, opts) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest(url, __assign(__assign({}, opts), { method: 'PATCH' }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return HttpClient;
}());
export default HttpClient;
